import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, browserHistory } from 'react-router';
import BlitzAPI from '../../api/BlitzAPI';
import ChatRoomForm from './ChatRoomForm';
import { handleFormErrors } from '../form/utils';

class ChatRoomEdit extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      chat_channel: null,
    };
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    BlitzAPI.getChatRoom(this.props.params.chatRoomId).then(
      response => this.setState({ chat_channel: response.data.data }),
    );
  }

  handleSubmit(values) {
    return BlitzAPI.patchChatRoom(this.props.params.chatRoomId, { chat_channel: values }).then(
      response => browserHistory.push('/chatrooms'),
    ).catch(
      handleFormErrors,
    );
  }

  render() {
    if (!this.state.chat_channel) {
      return <div><h1>Loading</h1></div>;
    }
    return (
      <div>
        <h1>Edit Chat Room</h1>
        <ChatRoomForm onSubmit={this.handleSubmit} initialValues={this.state.chat_channel} />
      </div>
    );
  }
}

ChatRoomEdit.propTypes = {
  params: PropTypes.object,
};

export default withRouter(ChatRoomEdit);



// WEBPACK FOOTER //
// ./src/cms/chat/ChatRoomEdit.js